export const PaymentType = {
  PK: {
    PAYMENT: {
      JC: 'jazzcash',
      JCQr: 'jazzcashQr',
      EP: 'easypaisa',
      EPQr: 'easypaisaQr',
      EPBill: 'bill',
      Card: 'card',
      OneLink: 'onelink'
    },
    TRANSFER: {
      JC: 'jazzcash',
      EP: 'easypaisa',
      Card: 'card',
      OneLink: 'onelink'
    }
  },
  BD: {
    PAYMENT: {
      BKash: 'bkash',
      Nagad: 'nagad',
      Rocket: 'rocket'
    },
    TRANSFER: {
      BKash: 'bkash',
      Nagad: 'nagad',
      Rocket: 'rocket'
    }
  }
};

export const getEmptyConfig = (country, type) => {
  const config = {};
  const types = PaymentType[country][type];
  Object.values(types).forEach(key => {
    config[key] = '';
  });
  return config;
}; 